import { styled } from "@mui/material/styles";
import { Box, Grid2, Typography } from "@mui/material";
import { shadows } from "../../../theme/theme";

export const PromosGrid = styled(Grid2)({
  display: "flex",
  justifyContent: "center",
});

export const PromoCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: "#fff",
  borderRadius: "30px",
  boxShadow: shadows.card,
  padding: theme.spacing(2),
  width: 250,
  height: 420,
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: shadows.cardHover,
  },
  [theme.breakpoints.down("sm")]: {
    width: 300,
    height: 500,
  },
}));

export const PromoImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "330px",
  borderRadius: theme.spacing(2),
  objectFit: "cover",
  [theme.breakpoints.down("sm")]: {
    maxHeight: "400px",
    height: "100%",
  },
}));

export const PromoTitle = styled(Typography)(({ theme }) => ({
  marginTop: "auto",
  fontFamily: "'Gotham', sans-serif",
  fontSize: "14px",
  fontWeight: 700,
  color: theme.palette.text.primary,
  textTransform: "uppercase",
  textAlign: "center",
  letterSpacing: "0.2px",
}));
